import React, { Component } from "react";
import moment from "moment";
import { Modal, DatePicker, Select, Input, Row, Col, message } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { ButtonItem, SelectEmpleadosItem } from "../../../../Components/Items";
import SelectActivoCMMS from "./SelectActivoCMMS";
import { cmmsPost, fechaDiaPayload, TIPOS_SERVICIO } from "../cmmsComun";
import "../cmms.css";

const { Option } = Select;

// "Programar servicio": poner en la agenda un servicio a cualquier equipo, el día que sea, sin
// nada anterior (sin programa del contrato ni sugerencia). Si el equipo ya tenía ese servicio
// pendiente en el programa de su contrato, se le pone la fecha a ése. No crea la Orden de
// Servicio: ésta nace al iniciar el servicio (desde la agenda o la app).
// props: visible, fechaInicial (moment), activoInicial ({ _id, texto }), onCerrar(programado)
class ModalProgramarServicioCMMS extends Component {
    state = { activoId: null, activoTexto: "", fecha: null, tipoServicio: 1, empleadoId: null, notas: "", guardando: false };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible)
            this.setState({
                activoId: this.props.activoInicial?._id || null,
                activoTexto: this.props.activoInicial?.texto || "",
                fecha: this.props.fechaInicial ? moment(this.props.fechaInicial) : moment(),
                tipoServicio: 1,
                empleadoId: null,
                notas: "",
                guardando: false,
            });
    }

    guardar = async () => {
        const { activoId, fecha, tipoServicio, empleadoId, notas } = this.state;
        if (!activoId) return message.warning("Elija el equipo");
        if (!fecha) return message.warning("Elija la fecha");
        this.setState({ guardando: true });
        try {
            const res = await cmmsPost(this.props, "agregarPlanAgendaCMMS", {
                activoId,
                fechaPlaneada: fechaDiaPayload(fecha),
                tipoServicio,
                cambiarEmpleado: true,
                empleadoId: empleadoId || null,
                notas,
                libre: true,
            });
            if (res.data.success !== 2) return message.error(res.data.message || "No se pudo programar");
            message.success(
                res.data.enPrograma
                    ? `Ya estaba pendiente en el programa de su contrato: quedó para el ${fecha.format("DD/MM/YYYY")}`
                    : `Servicio programado para el ${fecha.format("DD/MM/YYYY")}`
            );
            this.props.onCerrar(true);
        } catch (error) {
            console.log(error);
            message.error("No se pudo programar");
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const { visible, onCerrar } = this.props;
        const s = this.state;
        return (
            <Modal
                className="cmms-modal"
                visible={visible}
                onCancel={() => onCerrar(false)}
                maskClosable={false}
                width={window.innerWidth > 720 ? 640 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        <CalendarOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">Programar servicio</div>
                            <div className="cmms-modal-subtitulo">A cualquier equipo, el día que sea. Queda en la agenda (y en la app) de ese día.</div>
                        </div>
                    </div>
                }
                footer={
                    <div className="cmms-modal-pie" style={{ padding: 0, border: 0 }}>
                        <span className="cmms-modal-pie-nota">No crea la Orden de Servicio: ésta nace al iniciar el servicio.</span>
                        <ButtonItem type="default" htmlType="button" onClick={() => onCerrar(false)}>
                            Cancelar
                        </ButtonItem>
                        <ButtonItem type="primary" htmlType="button" icon={<CalendarOutlined />} loading={s.guardando} disabled={!s.activoId || !s.fecha} onClick={this.guardar}>
                            Programar
                        </ButtonItem>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo">
                    <div className="cmms-etiqueta-campo">Equipo</div>
                    <SelectActivoCMMS
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        value={s.activoId}
                        textoInicial={s.activoTexto}
                        onChange={(activoId) => this.setState({ activoId })}
                    />
                    <Row gutter={12} style={{ marginTop: 10 }}>
                        <Col xs={24} sm={10}>
                            <div className="cmms-etiqueta-campo">Fecha</div>
                            <DatePicker format="DD/MM/YYYY" allowClear={false} style={{ width: "100%" }} value={s.fecha} onChange={(fecha) => fecha && this.setState({ fecha })} />
                        </Col>
                        <Col xs={24} sm={14}>
                            <div className="cmms-etiqueta-campo">Tipo de servicio</div>
                            <Select style={{ width: "100%" }} value={s.tipoServicio} onChange={(tipoServicio) => this.setState({ tipoServicio })}>
                                {TIPOS_SERVICIO.map((t) => (
                                    <Option key={t.value} value={t.value}>
                                        {t.label}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                    <div className="cmms-etiqueta-campo" style={{ marginTop: 10 }}>
                        Ingeniero
                    </div>
                    <SelectEmpleadosItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        width="100%"
                        placeholder="Para todos (sin ingeniero)"
                        value={s.empleadoId || undefined}
                        onChange={(empleadoId) => this.setState({ empleadoId: empleadoId || null })}
                    />
                    <div className="cmms-etiqueta-campo" style={{ marginTop: 10 }}>
                        Notas
                    </div>
                    <Input.TextArea rows={2} maxLength={1000} placeholder="Opcional (ej. lo pidió el área, llevar refacción…)" value={s.notas} onChange={(e) => this.setState({ notas: e.target.value })} />
                    <div className="cmms-ayuda" style={{ marginTop: 8 }}>
                        Si el equipo ya tenía ese mismo servicio pendiente en el programa de su contrato, se le pone esta fecha a ése (no se duplica). Si no, queda como un servicio aparte, fuera del avance del contrato.
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ModalProgramarServicioCMMS;
